import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapDrawerLocation from '../enums/MapDrawerLocation';
import MapLocation from '../enums/MapLocation';
import MapOverlay from '../enums/MapOverlay';

type logMapOverlayDisplayedParams = {
  is_locked?: boolean;
  map_drawer_location?: MapDrawerLocation;
  map_location: MapLocation;
  map_overlay: MapOverlay;
};

/**
 * An overlay or detail layer became visible to the user in the map layer menu. Fires at most once per layer per presentation of the menu, so it measures which layers a user actually saw rather than how far they scrolled.
 * @param params - Attributes to log with the amplitude event
 * @param params.is_locked - Whether the layer was displayed with a Plus or Peak badge, meaning the user is not entitled to it.
 * @param params.map_drawer_location - The drawer tab that the map layer was in.
 * @param params.map_location - The location of the map where the interaction occurred
 * @param params.map_overlay - A string representing the map overlay that was displayed.
 */
const logMapOverlayDisplayed = (
  { is_locked, map_drawer_location, map_location, map_overlay }: logMapOverlayDisplayedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'map overlay displayed',
    { 'is locked': is_locked, 'map drawer location': map_drawer_location, 'map location': map_location, 'map overlay': map_overlay },
    callback
  );
};

export default logMapOverlayDisplayed;
